export default __webpack_public_path__ + "static/media/facerecognitionapp.2ee194f1.png";